export default __webpack_public_path__ + "static/media/Logo.425530c5.svg";